import * as yup from 'yup';

const userFormSchema = yup.object().shape({
  email: yup.string().email().required('Required'),
  name: yup.string().required('Required'),
  // eslint-disable-next-line react/forbid-prop-types
  clients: yup.array(yup.number()),
  isAdmin: yup.bool(),
  isInternal: yup.bool(),
});

export default userFormSchema;
